/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UnitSystemType = {
    Imperial: 'IMPERIAL',
    Metric: 'METRIC'
} as const;
export type UnitSystemType = typeof UnitSystemType[keyof typeof UnitSystemType];

